import React, { createContext, useContext, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';

import useJwt from '@src/auth/jwt/useJwt';
import isSigned from '@src/services/hooks/VerificationSigningTerms/useVerificationSigningTerms';

interface VerificationSigningTermsContextProps {
  isAuthenticated: boolean;
  hasSignedTerms: boolean;
  checkTerms: () => Promise<void>;
}

const VerificationSigningTermsContext =
  createContext<VerificationSigningTermsContextProps | null>(null);

export const VerificationSigningTermsProvider: React.FC = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [hasSignedTerms, setHasSignedTerms] = useState(false);
  const history = useHistory();

  const checkTerms = async () => {
    try {
      const token = useJwt.getToken();
      const storedUserData = localStorage.getItem('userData');
      const userData = storedUserData ? JSON.parse(storedUserData) : null;
      if (token) {
        setIsAuthenticated(true);
        const data = await isSigned(token);
        const hasSigned = data.isSigned;
        setHasSignedTerms(hasSigned);
        const { idrepresentative } = data;
        // if (!hasSigned && !userData?.isTheSupport) {
        //   if (userData.iduser === idrepresentative) {
        //     history.push('/signing-of-terms');
        //   } else {
        //     history.push('/notice-of-terms');
        //   }
        // }
      } else {
        setIsAuthenticated(false);
      }
    } catch (error) {
      console.error('Erro ao verificar os termos:', error);
    }
  };

  useEffect(() => {
    checkTerms();
  }, []);

  return (
    <VerificationSigningTermsContext.Provider
      value={{ isAuthenticated, hasSignedTerms, checkTerms }}
    >
      {children}
    </VerificationSigningTermsContext.Provider>
  );
};

export const useAuth = () => {
  return useContext(VerificationSigningTermsContext);
};
